import { AppContainer } from './AppContainer';
import './global.css';
import './i18n';
import { NotificationProvider } from './shared/notification/NotificationContext';
import { useTranslation } from 'react-i18next';
import { AuthProvider } from './shared/hooks/AuthContext';
import { AppRouter } from './pages/AppRouter';

function App() {
  const { t } = useTranslation();

  return (
    <NotificationProvider
      defaultModalHeading={t('globalNotifications.modalHeading')}
      defaultModalConfirmationButtonLabel={t(
        'globalNotifications.modalConfirm'
      )}
      defaultModalAbortButtonLabel={t('globalNotifications.modalAboard')}
      defaultModalContent={t('globalNotifications.modalHint')}
      defaultAlertErrorMessage={t('globalNotifications.alertError')}
      defaultAlertSuccessMessage={t('globalNotifications.alertSuccess')}
    >
      <AppContainer>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </AppContainer>
    </NotificationProvider>
  );
}

export default App;
